import { TranslationContextProvider } from '../../../../components/discover/aivy-pdf-reports/context/general-translations'
import { useUserContext } from '../../../../context'
import { isSet } from '../../../../helpers'
import { useDiscover } from '../../hooks/useDiscover'
import { EVALUATION_CONTEXT } from '../../utils'
import RequirementProfileSection from '../RequirementProfileSection'

export default function ConditionalRequirementProfileSection({
  career,
  talent,
  requirementProfile,
  className = '',
  isLoading
}) {
  const { selectedResult } = useDiscover()
  const { activeSpace } = useUserContext()

  const hasCompletedOnboarding = true //activeSpace?.hasCompletedOnboarding ?? false
  const shouldRenderRequirementProfile =
    hasCompletedOnboarding &&
    isSet(requirementProfile) &&
    (selectedResult === EVALUATION_CONTEXT.REQUIREMENTPROFILE ||
      (isSet(career) && !isSet(talent)))

  if (!shouldRenderRequirementProfile && !isLoading) return null

  return (
    <TranslationContextProvider data={requirementProfile}>
      <RequirementProfileSection
        career={career}
        talent={talent}
        requirementProfile={requirementProfile}
        className={className}
        isLoading={isLoading}
      />
    </TranslationContextProvider>
  )
}
